import { Mapper } from "../../../../base/utils/mapper";
import { FacturaTerceroResponseModel } from "../../../../domain/models/consult/factura-tercero-response.model";
import { FacturaTerceroResponseEntity } from "../entities/factura-tercero-response.entity";



export class FacturaTerceroImplementationRepositoryMapper extends Mapper<FacturaTerceroResponseEntity, FacturaTerceroResponseEntity> {
	mapFrom(param: FacturaTerceroResponseEntity): FacturaTerceroResponseModel {
		return {
			data:param.data,
			isSuccess:param.isSuccess,
			message:param.message,
			errors:param.errors
		};
	}
	mapTo(param: FacturaTerceroResponseModel): FacturaTerceroResponseEntity {
		return {
			data:param.data,
			isSuccess:param.isSuccess,
			message:param.message,
			errors:param.errors
		}
	}
}